/*
// mobile footer accordions
$(document).ready(function(){
  if (window.innerWidth < 768) {
    $('.site-footer .flex__item:not(.last) .site-footer__section-title').css('cursor','pointer');
    $('.site-footer .flex__item:not(.last) .site-footer__section-title').parents(".flex__item").siblings(".flex__item").find(".site-footer__section-title").nextUntil("h4").slideToggle(0);

    $('.site-footer .flex__item:not(.last) .site-footer__section-title').click(function() {
      $(this).parents(".flex__item").siblings(".flex__item").find(".site-footer__section-title").nextUntil("h4").slideUp();
      $(this).nextUntil("h4").slideToggle();
    });
  }
  
  $( window ).resize(function() {
    if (window.innerWidth < 768) {
      $('.site-footer .flex__item:not(.last) .site-footer__section-title').css('cursor','pointer');
      $('.site-footer .flex__item:not(.last) .site-footer__section-title').parents(".flex__item").siblings(".flex__item").find(".site-footer__section-title").nextUntil("h4").slideToggle(0);

      $('.site-footer .flex__item:not(.last) .site-footer__section-title').click(function() {
        $(this).parents(".flex__item").siblings(".flex__item").find(".site-footer__section-title").nextUntil("h4").slideUp();
        $(this).nextUntil("h4").slideToggle();
      });
    }
  });
});
*/

// instafeed volume workaround
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(function() {
//   	console.log("Lightboxes configured");
    let boxes = [...document.getElementsByClassName("instafeed-lightbox")];
  	let videos = [...document.getElementsByTagName("video")];
    boxes.map(box => {
      box.addEventListener("click", () => {
                           videos.map(video => {
                             video.pause();
                           });
      });
    });
  }, 3000);
});